import { useState } from 'react';
import { useAuth } from '@/lib/auth';
import AccountSelector from './AccountSelector';
import GoalSelector from './GoalSelector';
import CampaignTypeFilter from './CampaignTypeFilter';
import QuickWins from './QuickWins';
import Favorites from './Favorites';
import DateRangePicker, { type DateRange } from './DateRangePicker';

interface CommandBarProps {
  onSendPrompt: (prompt: string) => void;
  onGoalChange: (goal: string) => void;
  onCampaignTypeChange: (type: string) => void;
  onAccountChange: (accountId: string, accountName: string) => void;
  onRestoreContext: (context: { account_id?: string | null; goal?: string | null; campaign_type?: string | null }) => void;
  onDateRangeChange: (range: DateRange) => void;
  goal: string;
  campaignType: string;
  selectedAccountId: string;
  dateRange: DateRange;
  disabled?: boolean;
}

export default function CommandBar({
  onSendPrompt,
  onGoalChange,
  onCampaignTypeChange,
  onAccountChange,
  onRestoreContext,
  onDateRangeChange,
  goal,
  campaignType,
  selectedAccountId,
  dateRange,
  disabled,
}: CommandBarProps) {
  const { user } = useAuth();
  const [showFavorites, setShowFavorites] = useState(false);

  const isAgent = user?.plan === 'agent' || user?.email?.toLowerCase().endsWith('@zimamedia.com');

  if (!isAgent) return null;

  return (
    <div className="command-bar">
      <div className="command-bar-row">
        <div className="command-bar-selectors">
          <AccountSelector
            selectedAccountId={selectedAccountId}
            onAccountChange={onAccountChange}
            disabled={disabled}
          />
          <GoalSelector
            goal={goal}
            onGoalChange={onGoalChange}
            disabled={disabled}
          />
          <CampaignTypeFilter
            campaignType={campaignType}
            onCampaignTypeChange={onCampaignTypeChange}
            disabled={disabled}
          />
          <DateRangePicker
            dateRange={dateRange}
            onDateRangeChange={onDateRangeChange}
            disabled={disabled}
          />
          <QuickWins onSendPrompt={onSendPrompt} disabled={disabled} />
        </div>
        <div className="command-bar-actions">
          <Favorites
            onSendPrompt={onSendPrompt}
            onRestoreContext={onRestoreContext}
            currentAccountId={selectedAccountId}
            currentGoal={goal}
            currentCampaignType={campaignType}
            visible={showFavorites}
            onToggle={() => setShowFavorites(!showFavorites)}
          />
        </div>
      </div>
    </div>
  );
}
